module.exports = __webpack_public_path__ + "static/media/centeredSalonMarker.63e06926.svg";